export default __webpack_public_path__ + "static/Overlay-1c3d429b67ec05f35a1270384efbd145.gif";